import _createForOfIteratorHelper from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _regenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { deleteProduct, copyProduct, getClassify, getBrand, getDeliveryChannel, getSourcearea, getTransport, getProductList2, getProductOptions, soldout, itemupshelf, offShelfProductOption, onShelfProductOption, syncProductContent } from '@/services/productDetail';
import pic from '@/assets/test.png';
import product_default from '@/assets/img/product_default.png';
import moment from 'moment';
import editableCell from '@/pages/productmanager/components/editableCell.vue';
import { TreeSelect } from 'ant-design-vue';
import { getGoodsGroupedList, getsrxList } from '@/services/product/goodsGrouped.js';
var SHOW_PARENT = TreeSelect.SHOW_PARENT;
import { formatMoney, parseTime } from "@/utils/util.js";
import axios from 'axios';

/* function onChange(pagination, filters, sorter) {
	console.log('params', pagination, filters, sorter);
} */

export default {
  name: 'productList',
  i18n: require('./i18n-productList'),
  components: {
    editableCell: editableCell,
    TreeSelect: TreeSelect
  },
  watch: {
    '$route.query.nostock': function $routeQueryNostock() {
      if (this.$route.query.nostock) {
        this.queryParam.productName = '';
        this.queryParam.startProductNo = '';
        this.queryParam.endProductNo = '';
        this.queryParam.productClassify = [];
        this.queryParam.endProductSkuno = '';
        this.queryParam.startProductSkuno = '';
        this.queryParam.startProductPrice = '';
        this.queryParam.endProductPrice = '';
        this.queryParam.startProductPointnum = '';
        this.queryParam.endProductPointnum = '';
        this.queryParam.startProductStocknum = '';
        this.queryParam.endProductStocknum = '';
        this.queryParam.startStockDay = '';
        this.queryParam.endStockDay = '';
        this.queryParam.productShelfTime = [];
        this.queryParam.productCreateTime = [];
        this.queryParam.productStatus = undefined;
        this.queryParam.transportType = undefined;
        this.queryParam.productDelivery = undefined;
        this.queryParam.productBrandid = undefined;
        this.queryParam.productChannelid = undefined;
        this.queryParam.productSourceareaid = undefined;
        this.queryParam.stockSyn = undefined;
        this.queryParam.startProductRate = '';
        this.queryParam.endProductRate = '';
        this.queryParam.nostock = this.$route.query.nostock + "";
        this.page = 1;
        this.getProductList();
      }
    }
  },
  data: function data() {
    var columns = [{
      dataIndex: 'productNo',
      key: 'productNo',
      slots: {
        title: 'productNoSlots'
      },
      scopedSlots: {
        customRender: 'productNoScopedSlots'
      },
      width: '9%'
    }, {
      title: this.$t('productList.productImage'),
      dataIndex: 'productImage',
      key: 'productImage',
      align: 'center',
      scopedSlots: {
        customRender: 'listImgSrcScopedSlots'
      },
      width: '8%'
    }, {
      title: this.$t('productList.productName'),
      dataIndex: 'productName',
      key: 'productName',
      scopedSlots: {
        customRender: 'productNameScopedSlots'
      },
      width: '20%'
    }, {
      title: this.$t('newProductList.rongliang'),
      dataIndex: 'capacity',
      key: 'capacity',
      scopedSlots: {
        customRender: 'capacity'
      },
      width: '8%'
    }, {
      title: this.$t('productList.productStatus'),
      dataIndex: 'productStatus',
      key: 'productStatus',
      scopedSlots: {
        customRender: 'statusScopedSlots'
      },
      width: '8%'
    }, {
      title: this.$t('newProductList.visitorVisible'),
      dataIndex: 'touristView',
      key: 'touristView',
      scopedSlots: {
        customRender: 'visitorVisibleScopedSlots'
      },
      width: '10%'
    }, {
      title: this.$t('productList.shelfTime'),
      dataIndex: 'productOnlinedate',
      key: 'productOnlinedate',
      scopedSlots: {
        customRender: 'productOnlinedateScopedSlots'
      },
      width: '8%'
    }, {
      title: this.$t('newProductList.createTimeErp'),
      dataIndex: 'erpCreateTime',
      key: 'erpCreateTime',
      scopedSlots: {
        customRender: 'createTimeErpScopedSlots'
      },
      sorter: true,
      // defaultSortOrder: 'descend',
      width: '13%'
    },
    // {
    // 	dataIndex: 'productPrice',
    // 	key: 'productPrice',
    // 	align: 'right',
    // 	width: '11%',
    // 	slots: {
    // 		title: 'sellPriceSlots'
    // 	},
    // 	scopedSlots: {
    // 		customRender: 'sellPriceScopedSlots'
    // 	}
    // },
    {
      title: this.$t('productList.stockNum'),
      dataIndex: 'productStocknum',
      key: 'productStocknum',
      scopedSlots: {
        customRender: 'stockNumScopedSlots'
      },
      align: 'center',
      width: '8%'
    }, {
      title: this.$t('productList.updateTime'),
      dataIndex: 'lastUpdateTime',
      key: 'lastUpdateTime',
      scopedSlots: {
        customRender: 'updateTimeScopedSlots'
      },
      // sorter:  (a, b) => { return a.lastUpdateTime> b.lastUpdateTime? 1 : -1 },
      // defaultSortOrder: 'descend',
      width: '10%'
    }, {
      title: this.$t('productList.operation'),
      key: 'operation',
      scopedSlots: {
        customRender: 'operation'
      },
      width: '120px'
    }];
    var innerColumns = [{
      dataIndex: 'productNo',
      key: 'productNo',
      slots: {
        title: 'productNoSlots'
      },
      scopedSlots: {
        customRender: 'productNoScopedSlots'
      },
      width: '9%'
    }, {
      title: this.$t('productList.specsName'),
      dataIndex: 'specValueName',
      key: 'specValueName',
      width: '10%'
    }, {
      title: this.$t('newProductList.rongliang'),
      dataIndex: 'capacity',
      key: 'capacity',
      scopedSlots: {
        customRender: 'capacity'
      },
      width: '8%'
    }, {
      title: this.$t('productList.productStatus'),
      dataIndex: 'productStatus',
      key: 'productStatus',
      scopedSlots: {
        customRender: 'statusScopedSlots'
      },
      width: '5%'
    }, {
      title: this.$t('newProductList.visitorVisible'),
      dataIndex: 'touristView',
      key: 'touristView',
      scopedSlots: {
        customRender: 'visitorVisibleScopedSlots'
      },
      width: '10%'
    }, {
      title: this.$t('productList.shelfTime'),
      dataIndex: 'productOnlinedate',
      key: 'productOnlinedate',
      scopedSlots: {
        customRender: 'productOnlinedateScopedSlots'
      },
      width: '8%'
    }, {
      title: this.$t('newProductList.createTimeErp'),
      dataIndex: 'erpCreateTime',
      key: 'erpCreateTime',
      scopedSlots: {
        customRender: 'createTimeErpScopedSlots'
      },
      sorter: function sorter(a, b) {
        return 1;
      },
      // defaultSortOrder: 'descend',
      width: '10%'
    },
    // {
    // 	dataIndex: 'productPrice',
    // 	key: 'productPrice',
    // 	align: 'right',
    // 	width: '10%',
    // 	slots: {
    // 		title: 'sellPriceSlots'
    // 	},
    // 	scopedSlots: {
    // 		customRender: 'sellPriceScopedSlots'
    // 	}
    // },
    {
      title: this.$t('productList.stockNum'),
      dataIndex: 'productStocknum',
      key: 'productStocknum',
      scopedSlots: {
        customRender: 'stockNumScopedSlots'
      },
      align: 'center',
      width: '8%'
    }, {
      title: this.$t('productList.updateTime'),
      dataIndex: 'lastUpdateTime',
      key: 'lastUpdateTime',
      // sorter: true,
      scopedSlots: {
        customRender: 'updateTimeScopedSlots'
      },
      width: '10%'
    }, {
      title: this.$t('productList.operation'),
      dataIndex: 'operation',
      key: 'operation',
      scopedSlots: {
        customRender: 'operation'
      },
      width: '12%'
    }];
    return {
      productDefaultImg: product_default,
      curExpandedRowKeys: [],
      leftCurrencySymbol: localStorage.getItem('leftCurrencySymbol'),
      rightCurrencySymbol: localStorage.getItem('rightCurrencySymbol'),
      //查询参数
      erpSyncDatetime: '',
      totalNum: 0,
      cloneQueryParam: {},
      page: 1,
      size: 20,
      orderWay: 2,
      //  排序方式（1升序2降序）
      orderType: 2,
      //  排序字段（1ERP创建时间 2更新时间）
      queryParam: {
        productName: '',
        startProductNo: '',
        endProductNo: '',
        productClassify: [],
        startStockDay: '',
        endStockDay: '',
        productShelfTime: [],
        productCreateTime: [],
        productStatus: undefined,
        transportType: undefined,
        productBrandid: undefined,
        productSourceareaid: undefined,
        productBarcode: undefined,
        supplierCode: undefined,
        touristView: undefined,
        stockSyn: undefined,
        startProductStocknum: '',
        endProductStocknum: '',
        productBelong: undefined
        // productGroupIdStr:[]
      },
      //展开  收起
      showAdvanced: false,
      columns: columns,
      innerColumns: innerColumns,
      // innerData,
      productList: [],
      isTableLoading: false,
      //表格勾选行
      selectedRowKeys: [],
      //分类基础数据
      categoryList: [],
      //分类显示规则 如果次级分类全部勾选，显示上级分类
      SHOW_PARENT: SHOW_PARENT,
      //首选运输方式基础数据
      transportModeList: [],
      //次选运输方式基础数据
      transportModeList2: [],
      //品牌基础数据
      brandList: [],
      //发货渠道基础数据
      deliveryChannelList: [],
      //原产地基础数据
      sourceAreaList: [],
      queryLoading: false,
      changProductStatus0Loading: false,
      changProductStatus1Loading: false,
      changProductStatus2Loading: false,
      changProductStatus3Loading: false,
      exportLoading: false,
      baseUrl: process.env.VUE_APP_API_BASE_URL,
      deliveryChannel: 1,
      //点击删除  不直接显示确认框
      deleteVisible: false,
      addCategoryModal: false,
      addCategoryFromData: {
        categoryList: []
      },
      rules: {
        categoryList: [{
          required: true,
          message: this.$t('productList.chooseProductCategory'),
          trigger: 'change'
        }, {
          required: true,
          message: this.$t('productList.chooseProductCategory'),
          trigger: 'blur'
        }]
      },
      srxList: [],
      visitorVisibleList: [{
        id: 1,
        name: this.$t('newProductList.visible')
      }, {
        id: 0,
        name: this.$t('newProductList.noVisible')
      }],
      goodsGroupedList: [],
      syncLoading: false
    };
  },
  computed: {
    //查询栅格占据的跨度
    actionWidth: function actionWidth() {
      if (this.showAdvanced) {
        if (this.deliveryChannel == 1 || this.deliveryChannel == null || this.deliveryChannel == undefined) {
          return 24;
        } else {
          return 24;
        }
      } else {
        return 24;
      }
    },
    synchronizedStockTimeStr: function synchronizedStockTimeStr() {
      return this.$t('productList.lastSynchronizedStockTime') + ' ' + this.erpSyncDatetime;
    }
  },
  mounted: function mounted() {
    //区分运营方式
    this.deliveryChannel = localStorage.getItem('deliveryChannel');
    console.log(this.deliveryChannel, 'channel');
    var channelObj = {
      title: this.$t('productList.deliveryChannel'),
      dataIndex: 'productChannel',
      key: 'productChannel',
      scopedSlots: {
        customRender: 'deliveryChannelScopedSlots'
      },
      width: '10%'
    };
    if (this.deliveryChannel == 1 || this.deliveryChannel == null || this.deliveryChannel == undefined) {
      this.columns.splice(3, 0, channelObj);
      this.innerColumns.splice(3, 0, channelObj);
    }
    var self = this;
    // self.getProductList();
    //获取路由参数query
    var query = self.$route.query;
    if (query.productBrandid) {
      query.productBrandid = parseInt(query.productBrandid);
    }
    if (query.productStatus) {
      query.productStatus = parseInt(query.productStatus);
    }
    if (query.productSourceareaid) {
      query.productSourceareaid = parseInt(query.productSourceareaid);
    }
    if (query.productBrandid || query.productStatus || query.productSourceareaid) {
      this.showAdvanced = true;
    }
    self.queryParam = _objectSpread(_objectSpread({}, self.queryParam), query);
    console.log(self.queryParam);
    self.init();
  },
  methods: {
    // 获取一维规格下的商品数量
    computedSpecCount: function computedSpecCount(record) {
      if (record.optionId && _.isString(record.optionId)) {
        return record.optionId.split(',').length;
      } else {
        return 0;
      }
    },
    // 获取一维规格下的上架，下架，终卖商品数量
    computedProductStatusCount: function computedProductStatusCount(record) {
      if (record.productStatus && _.isString(record.productStatus)) {
        var statusList = record.productStatus.split(',');
        var onCount = 0;
        var offCount = 0;
        var stopCount = 0;
        for (var i = 0; i < statusList.length; i++) {
          // 状态条件(-1:全部  0:下架 1:上架，3：终卖)
          if (statusList[i] == 1) {
            onCount++;
          } else if (statusList[i] == 0) {
            offCount++;
          } else if (statusList[i] == 3) {
            stopCount++;
          }
        }
        return {
          onCount: onCount,
          offCount: offCount,
          stopCount: stopCount
        };
      } else {
        return {
          onCount: 0,
          offCount: 0,
          stopCount: 0
        };
      }
    },
    //多规格展开折叠事件
    expand: function expand(expanded, record) {
      //expanded 是否展开状态
      var self = this;
      self.curExpandedRowKeys.push(record.id);
      console.log(expanded, record);
      var queryParam = _.cloneDeep(self.cloneQueryParam);
      if (expanded) {
        var param = {
          condition: queryParam
        };
        param.condition['productId'] = record.id;
        getProductOptions(param).then(function (response) {
          if (response.data.code == 200) {
            record["innerData"] = response.data.data;
            console.log(response.data.data);
          }
        });
      } else {
        if (self.curExpandedRowKeys.length) {
          self.curExpandedRowKeys = this.curExpandedRowKeys.filter(function (v) {
            return v !== record.id;
          });
        }
      }
    },
    //初始化
    init: function init() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var self, getObjClassify, getObj, params, res2, res3;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              self = _this;
              self.queryLoading = true;
              self.page = 1;
              self.getProductList();
              getObjClassify = {
                type: 1
              };
              getClassify(getObjClassify).then(function (response) {
                if (response.data.code == 200) {
                  self.categoryList = response.data.data;
                }
              });

              //获取运输方式列表
              getTransport().then(function (response) {
                if (response.data.code == 200) {
                  self.transportModeList = response.data.data;
                  //获取次选运输方式列表
                  // let obj = { id: -2, name: this.$t('productList.notSetting'), status: 0 }
                  // self.transportModeList2 = JSON.parse(JSON.stringify(self.transportModeList))
                  // self.transportModeList2.unshift(obj)
                }
              });

              // getSaleunit().then(response => {
              // 	if (response.data.code == 200) {
              // 		self.saleunitList = response.data.data;
              // 	}
              // });
              getObj = {
                statusType: 2
              };
              getBrand(getObj).then(function (response) {
                if (response.data.code == 200) {
                  self.brandList = response.data.data;
                }
              });
              getSourcearea(getObj).then(function (response) {
                if (response.data.code == 200) {
                  self.sourceAreaList = response.data.data;
                }
              });
              getDeliveryChannel(getObj).then(function (response) {
                if (response.data.code == 200) {
                  self.deliveryChannelList = response.data.data;
                }
              });
              // 获取商品分组列表
              params = {
                scene: 2
              };
              _context.n = 1;
              return getGoodsGroupedList(params);
            case 1:
              res2 = _context.v;
              if (res2.data.code == 200) {
                console.log(res2);
                _this.goodsGroupedList = res2.data.data.list.map(function (item) {
                  return {
                    value: item.groupId,
                    name: item.groupName
                  };
                });
              }
              // 获取仕入先列表
              _context.n = 2;
              return getsrxList();
            case 2:
              res3 = _context.v;
              if (res3.data.code == 200) {
                _this.srxList = res3.data.data.map(function (item) {
                  return {
                    id: item.supplierCode,
                    name: item.supplierName
                  };
                });
              }
              self.queryLoading = false;
              //				console.log(self.classifyList);
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    editProduct: function editProduct(row) {
      var routeData = this.$router.resolve({
        path: 'productDetail',
        query: {
          id: row.id,
          vid: row.specFlag != 2 ? row.id : row.optionId
        }
      });
      window.open(routeData.href, '_blank');
      // this.$router.push({path:'productDetail',query:{id: id}})
    },
    goCommentList: function goCommentList(data) {
      this.$router.push({
        path: 'comment',
        query: {
          productNo: data.productNo
        }
      });
    },
    queryProductList: function queryProductList() {
      this.page = 1;
      if (typeof this.$route.query.nostock != 'undefined') {
        this.$router.replace({
          query: {}
        });
      }
      this.getProductList();
    },
    //获取商品列表
    getProductList: function getProductList() {
      var self = this;

      /* 有展开的行时，上架下架商品时，需要把展开改为折叠，需要把curExpandedRowKeys设为空，不然页面显示不正常，
      像我们做嵌套表格上面一般还有配有查询条件，查询的时候一定记得执行一下curExpandedRowKeys置空。不然用户展开嵌套表浏览后再去查询，嵌套表格是展开的。没有收起的效果。 */
      // let newParam = _.cloneDeep(self.queryParam)
      self.curExpandedRowKeys = [];
      var param = {
        page: self.page,
        size: self.size,
        scene: 1,
        orderType: self.orderType,
        orderWay: self.orderWay,
        condition: self.queryParam
      };
      param.condition['startProductOnlinedate'] = self.queryParam.productShelfTime[0];
      param.condition['endProductOnlinedate'] = self.queryParam.productShelfTime[1];
      param.condition['startERPCreateTime'] = self.queryParam.productCreateTime[0];
      param.condition['endERPCreateTime'] = self.queryParam.productCreateTime[1];
      // param.condition['productGroupIdStr'] = newParam.productGroupIdStr.join(',');
      self.isTableLoading = true;
      // console.log(param.condition)
      getProductList2(param).then(function (response) {
        if (response.data.code == 200) {
          self.cloneQueryParam = _.cloneDeep(self.queryParam);
          self.totalNum = response.data.data.totalNum;
          self.erpSyncDatetime = response.data.data.erpSyncDatetime;
          var productList = response.data.data.productVoList;
          var _iterator = _createForOfIteratorHelper(productList),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var product = _step.value;
              product.innerData = [];
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          self.productList = productList;
          console.log('self.productList', self.productList);
          if (_.isArray(self.productList) && self.productList.length > 0) {
            self.productList = self.productList.map(function (item) {
              if (item.specFlag != 2) {
                item.specCount = self.computedSpecCount(item);
                var _self$computedProduct = self.computedProductStatusCount(item),
                  onCount = _self$computedProduct.onCount,
                  offCount = _self$computedProduct.offCount,
                  stopCount = _self$computedProduct.stopCount;
                item.productOnCount = onCount;
                item.productOffCount = offCount;
                item.productStopCount = stopCount;
              }
              return item;
            });
          }

          // console.log(self.productList)
        }
      }).finally(function () {
        self.isTableLoading = false;
        self.queryLoading = false;
      });
    },
    /* 		showAddCategoryModal() {
    			let self = this;
    			if (self.selectedRowKeys.length == 0) {
    				self.$message.warning(this.$t('productList.chooseProduct'));
    				return;
    			}
    			self.addCategoryModal = true;
    		}, */
    getRowClass: function getRowClass(row, index) {
      // console.log(row, index);
      if (row.specFlag == 2) {
        return 'hideExpendIco';
      }
    },
    /* 		addCategory() {
    			let self = this;
    			self.$refs.addCategoryModal.validate(valid => {
    				if (valid) {
    					//验证通过组装数据
    				} else {
    					return false;
    				}
    			});
    		}, */
    deleteOneProductConfirm: function deleteOneProductConfirm(record) {
      var _this2 = this;
      deleteProduct(record.id).then(function (response) {
        if (response.data.code == 200) {
          record.deleteVisible = false;
          _this2.page = 1;
          _this2.getProductList();
          _this2.$message.success(_this2.$t('public.deleteSuccessfully'));
        }
      });
    },
    deleteOneCancel: function deleteOneCancel(record) {
      record.deleteVisible = false;
    },
    //点击删除的时候，不关闭
    handleMenuClick: function handleMenuClick(record) {
      record.deleteVisible = true;
    },
    //控制显示流程
    handleVisibleChange: function handleVisibleChange() {
      var self = this;
      if (self.selectedRowKeys.length == 0) {
        self.$message.warning(this.$t('productList.chooseProduct'));
      } else {
        self.deleteVisible = true;
      }
    },
    deleteConfirm: function deleteConfirm() {
      var self = this;
      self.changProductStatus(0);
    },
    deleteCancel: function deleteCancel() {
      this.deleteVisible = false;
    },
    changProductStatus: function changProductStatus(type) {
      var _this3 = this;
      var self = this;
      if (self.selectedRowKeys.length == 0) {
        self.$message.warning(this.$t('productList.chooseProduct'));
        return;
      }
      /* if (type == 0) {
      	self.$message.success(this.$t('productList.deleteSuccessfully'));
      	this.deleteVisible = false;
      } */

      if (type == 1) {
        self.changProductStatus2Loading = true;
        itemupshelf({
          'productIds': self.selectedRowKeys.toString()
        }).then(function (response) {
          if (response.data.code == 200) {
            _this3.page = 1;
            self.getProductList();
            self.$message.success(_this3.$t('productList.onTheShelfSuccessfully'));
          }
          self.changProductStatus2Loading = false;
        }).finally(function () {
          self.changProductStatus2Loading = false;
        });
      }
      if (type == 2) {
        self.changProductStatus1Loading = true;
        soldout(self.selectedRowKeys.toString(), 1).then(function (response) {
          if (response.data.code == 200) {
            _this3.page = 1;
            self.getProductList();
            self.$message.success(_this3.$t('productList.offTheShelfSuccessfully'));
          }
          self.changProductStatus1Loading = false;
        }).finally(function () {
          self.changProductStatus2Loading = false;
        });
      }
      // 终卖的操作
      if (type == 3) {
        self.changProductStatus3Loading = true;
        soldout(self.selectedRowKeys.toString(), 2).then(function (response) {
          if (response.data.code == 200) {
            _this3.page = 1;
            self.getProductList();
            self.$message.success(_this3.$t('newProductList.overshellSuccess'));
          }
          self.changProductStatus3Loading = false;
        }).finally(function () {
          self.changProductStatus2Loading = false;
        });
      }
      // this.selectedRowKeys = []
    },
    reComputedProduct: function reComputedProduct(parentRecord) {
      if (_.isArray(parentRecord.innerData) && parentRecord.innerData.length > 0) {
        var productCount = 0;
        var onCount = 0;
        var offCount = 0;
        for (var i = 0; i < parentRecord.innerData.length; i++) {
          var product = parentRecord.innerData[i];
          if (product.productStatus == 0) {
            offCount++;
          } else if (product.productStatus == 1) {
            onCount++;
          }
          productCount++;
        }
        parentRecord.specCount = productCount;
        parentRecord.productOnCount = onCount;
        parentRecord.productOffCount = offCount;
      } else {
        parentRecord.specCount = 0;
        parentRecord.productOnCount = 0;
        parentRecord.productOffCount = 0;
      }
    },
    updateStatus: function updateStatus(record, type, parentRecord) {
      var _this4 = this;
      console.log(11222);
      var self = this;
      self.isTableLoading = true;
      var key = "updateStatusLoading" + record.id + type;
      if (typeof record[key] === 'undefined') {
        this.$set(record, key, false);
      }
      if (record[key]) return;
      record[key] = true;
      // 1上架 0下架 2终卖
      if (type == 1) {
        onShelfProductOption(record.id).then(function (response) {
          if (response.data.code == 200) {
            record.productStatus = 1;
            _this4.reComputedProduct(parentRecord);
            self.$message.success(_this4.$t('productList.onTheShelfSuccessfully'));
          }
        }).finally(function () {
          self.isTableLoading = false;
          record[key] = false;
        });
      } else if (type == 0) {
        offShelfProductOption(record.id, 1).then(function (response) {
          if (response.data.code == 200) {
            record.productStatus = 0;
            _this4.reComputedProduct(parentRecord);
            self.$message.success(_this4.$t('productList.offTheShelfSuccessfully'));
          }
        }).finally(function () {
          self.isTableLoading = false;
          record[key] = false;
        });
      }
      // 终卖
      else if (type == 2) {
        offShelfProductOption(record.id, 2).then(function (response) {
          if (response.data.code == 200) {
            record.productStatus = 2;
            _this4.reComputedProduct(parentRecord);
            self.$message.success(_this4.$t('newProductList.overshellSuccess'));
          }
        }).finally(function () {
          self.isTableLoading = false;
          record[key] = false;
        });
      }
    },
    //新增商品
    addProduct: function addProduct() {
      this.$router.push({
        path: 'productdetail'
      });
    },
    expandIcon: function expandIcon(props) {
      // console.log(props);
      console.log(444);
    },
    onCellChange: function onCellChange(key, dataIndex, value) {
      console.log(key, dataIndex, value);
      // const dataSource = [...this.dataSource];
      // const target = dataSource.find(item => item.key === key);
      // if (target) {
      // 	target[dataIndex] = value;
      // 	this.dataSource = dataSource;
      // }
    },
    onSelectChange: function onSelectChange(selectedRowKeys) {
      console.log('selectedRowKeys changed: ', selectedRowKeys);
      this.selectedRowKeys = selectedRowKeys;
    },
    onClose: function onClose(e) {
      console.log(e, 'I was closed.');
    },
    exportProduct: function exportProduct() {
      var _this5 = this;
      // document.querySelector("#exportProductForm").submit()
      var self = this;
      var param = _.cloneDeep(self.queryParam);
      param['startProductOnlinedate'] = self.queryParam.productShelfTime[0];
      param['endProductOnlinedate'] = self.queryParam.productShelfTime[1];
      param['startCreateTime'] = self.queryParam.productCreateTime[0];
      param['endCreateTime'] = self.queryParam.productCreateTime[1];
      param['productClassify'] = param['productClassify'].join();
      delete param.productCreateTime;
      axios.defaults.timeout = 5000;
      axios.defaults.withCredentials = true;
      self.exportLoading = true;
      axios.get(process.env.VUE_APP_API_BASE_URL + "/product/exportProduct", {
        responseType: 'blob',
        params: param
      }).then(function (res) {
        if (res.data.code) {
          //错误提示
        } else {
          var blob = new Blob([res.data], {
            type: 'application/vnd.ms-excel'
          });
          var elink = document.createElement('a');
          elink.download = "productExport_".concat(parseTime(new Date().getTime(), "{y}{m}{d}{h}{i}{s}"), ".xls");
          elink.style.display = 'none';
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        }
        self.exportLoading = false;
      }).catch(function (err) {
        _this5.$message.error(err);
        self.exportLoading = false;
      });
    },
    tableChange: function tableChange(pagination, filters, sorter, _ref) {
      var currentDataSource = _ref.currentDataSource;
      var self = this;
      console.log(sorter.order, 'sorter', sorter);
      var order = sorter.order || "descend";
      var orders = order === "descend" ? 2 : 1;
      self.page = pagination.current;
      self.size = pagination.pageSize;
      self.orderWay = orders;
      self.orderWay = sorter.order ? 1 : 2;
      self.curExpandedRowKeys = [];
      this.getProductList();
    },
    copyOneProductConfirm: function copyOneProductConfirm(row) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              // 调用复制的接口 拿到id后就跳转
              row.deleteVisible = false;
              if (!row.copyProductLoading) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              row.copyProductLoading = true;
              _context2.p = 2;
              _context2.n = 3;
              return copyProduct(row.id);
            case 3:
              res = _context2.v;
              if (res.data.code == 200) {
                _this6.$message.success(_this6.$t('public.copySuccessfully'));
                _this6.page = 1;
                _this6.getProductList();
                setTimeout(function () {
                  var id = res.data.data;
                  var routeData = _this6.$router.resolve({
                    path: 'productDetail',
                    query: {
                      id: id
                    }
                  });
                  window.open(routeData.href, '_blank');
                }, 500);
              }
            case 4:
              _context2.p = 4;
              row.copyProductLoading = false;
              return _context2.f(4);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, null, [[2,, 4, 5]]);
      }))();
    },
    copyOneCancel: function copyOneCancel(row) {
      row.deleteVisible = false;
    },
    getCheckboxProps: function getCheckboxProps(record) {
      if (record.specFlag !== 2) {
        var statusList = record.productStatus.split(',');
        var disabled = statusList.every(function (item) {
          return item == 3;
        });
        return {
          props: {
            disabled: disabled
          }
        };
      } else {
        return {
          props: {
            disabled: record.productStatus == 3
          }
        };
      }
    },
    gotoVisible: function gotoVisible(row) {
      var routeData = this.$router.resolve({
        path: '/goodsVisible/editGoodsVisible',
        query: {
          name: row.productNo,
          id: row.specFlag != 2 ? row.id : row.optionId
        }
      });
      window.open(routeData.href, '_blank');
    },
    syncProduct: function syncProduct() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _this7.syncLoading = true;
              _context3.n = 1;
              return syncProductContent();
            case 1:
              res = _context3.v;
              console.log(res, 'res');
              if (res.data.code == 200) {
                _this7.$message.success(_this7.$t('public.updateSuccessfully'));
                _this7.syncLoading = false;
                _this7.init();
              }
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    }
  }
};